import { Reward } from "@src/global_functions/backpackSdk/projects/rewards";
import { TextVariants } from "@src/straps/base/type/Text/Text";
import StatusNode from "./StatusNode";
import { rewardStatusRenderingOptions } from "../utils";

export default function RewardStatusNode({
  rewardStatus,
  textVariant,
}: {
  readonly rewardStatus: Reward["status"];
  readonly textVariant?: TextVariants;
}) {
  const { color, label } = rewardStatusRenderingOptions[rewardStatus];
  return (
    <StatusNode
      title={label}
      icon="dot-closed"
      iconColor={color}
      smallIcon
      textVariant={textVariant}
      dataTestId="reward-status-node"
    />
  );
}
